import useBrowserStorage from "./useBrowserStorage";

export default function useCurrentUserData() {
  const { getItem, setItem, removeItem } = useBrowserStorage();

  const getUserData = () => {
    return getItem("currentUser", "local");
  };

  const setUserData = (userData) => {
    setItem("currentUser", userData, "local");
  };

  const removeUserData = () => {
    removeItem("currentUser", "local");
  };

  const isCurrentUserMale = () => {
    const gender = getItem("currentUser", "local").gender;
    return gender === "male";
  };
  return {
    getUserData,
    setUserData,
    removeUserData,
    isCurrentUserMale,
  };
}
